var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoneybag({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91659 2.5H12.0833C12.4148 2.5 12.7327 2.6317 12.9671 2.86612C13.2016 3.10054 13.3333 3.41848 13.3333 3.75C13.3333 4.52355 13.026 5.26541 12.479 5.81239C11.932 6.35938 11.1901 6.66667 10.4166 6.66667H9.58325C8.8097 6.66667 8.06784 6.35938 7.52086 5.81239C6.97388 5.26541 6.66659 4.52355 6.66659 3.75C6.66659 3.41848 6.79828 3.10054 7.0327 2.86612C7.26712 2.6317 7.58506 2.5 7.91659 2.5Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33325 14.1667V13.3333C3.33325 11.5652 4.03563 9.86953 5.28587 8.61929C6.53612 7.36905 8.23181 6.66667 9.99992 6.66667C11.768 6.66667 13.4637 7.36905 14.714 8.61929C15.9642 9.86953 16.6666 11.5652 16.6666 13.3333V14.1667C16.6666 15.0507 16.3154 15.8986 15.6903 16.5237C15.0652 17.1488 14.2173 17.5 13.3333 17.5H6.66659C5.78253 17.5 4.93468 17.1488 4.30956 16.5237C3.68444 15.8986 3.33325 15.0507 3.33325 14.1667Z",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneybag);
export default __webpack_public_path__ + "static/media/moneybag.5b369ef16f86ba686c824b6f3352df66.svg";
export { ForwardRef as ReactComponent };